import React from 'react';

function Facebook() {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.50571 76.50571">
      <title>Social Media</title>
      <path d="M38.25285,0A38.25285,38.25285,0,1,0,76.50571,38.25285,38.252,38.252,0,0,0,38.25285,0Zm0,71.56932A33.31646,33.31646,0,1,1,71.56932,38.25285,33.31581,33.31581,0,0,1,38.25285,71.56932Z" fill="#bdbebf" />
      <path d="M32.83208,59.77151h8.60379V38.22575h6.00289l.63986-7.21385H41.43587V26.90334c0-1.7009.34168-2.37324,1.98649-2.37324h4.65625V17.04322H42.121c-6.40231,0-9.28891,2.81979-9.28891,8.21706V31.0119H28.35657v7.30426h4.47551Z" fill="#bdbebf" />
    </svg>
  );
}

export default Facebook;



// WEBPACK FOOTER //
// ./client/components/shared/SocialMediaLinks/icons/Facebook.js